module.exports = __webpack_public_path__ + "assets/img/ae3a2a9d95c0579d5cdaf98ee22d1a10.png";